/**
 * A small FREE / PRO tag beside a setting, copied from pdf-to-figma.
 *
 * It exists to disclose what an option costs AT THE MOMENT OF CHOOSING, rather than after the
 * designer has picked it and pressed Import. The original's note is worth keeping: the pattern
 * is borrowed from competitor plugins that use loud red PRO chips, and the borrowing stops at
 * the pattern — this uses the accent and muted tokens everything else here uses, so it reads as
 * information rather than as an advertisement.
 */

import { Text } from '@chakra-ui/react';

export type Tier = 'free' | 'pro';

export function TierBadge({ tier }: { tier: Tier }) {
  const isPro = tier === 'pro';
  return (
    <Text
      as="span"
      fontSize="9px"
      fontWeight="600"
      letterSpacing="wide"
      textTransform="uppercase"
      px="1"
      py="0.5"
      borderRadius="sm"
      bg={isPro ? 'figma.accentMuted' : 'figma.panelHover'}
      color={isPro ? 'figma.accent' : 'figma.textMuted'}
      lineHeight="1"
      flexShrink={0}
    >
      {isPro ? 'Pro' : 'Free'}
    </Text>
  );
}
